/**
 * 宣传分类
 */

import {
  get,
  post,
  put,
  del
} from '@/util/request'
import download from "@/util/download";

/**
 * 根据Id查询
 * @param {*} data
 * @returns
 */
export const SelectNewsCategoryById = (Id) => {
  return get('/api/app/NewsCategory?CurrentId=' + Id);
}

/**
 * 新增数据记录
 * @param {*} data
 * @returns
 */
export const AddNewsCategory = (data) => {
  return post('/api/app/NewsCategory', data, {});
}

/**
 * 更新数据记录
 * @param {*} data
 * @returns
 */
export const ModifyNewsCategory = (data) => {
  return put('/api/app/NewsCategory', data, {});
}

/**
 * 分页获取宣传分类
 * @param {*} data
 * @returns
 */
export const GetDataNewsCategoryList = (data) => {
  return post('/api/app/NewsCategory/list', data, {});
}

/**
 * 删除记录
 * @param {*} id
 * @returns
 */
export const DeleteNewsCategory = (id) => {
  return del('/api/app/NewsCategory/' + id, {}, {});
}

/**
 * 导出Excel
 * @param {*} id
 * @returns
 */
 export const ExportNewsCategory = (data) => {
  let defaluturl = `/api/app/NewsCategory/exportExcelFile`;
  let fileName = "宣传分类"
  return download(fileName, defaluturl, data);
}